import React, { useEffect, useState } from 'react';
import BookListing from './BooksListing';
import { columnTypes } from 'src/components/UI/atoms/ATMTable/ATMTable';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { setIsOpenAddDialog, setIsOpenEditDialog, setPage, setRowsPerPage, setSearchValue, setIsTableLoading, setItems, setTotalItems } from 'src/redux/slices/BookSlice';
import AddBookWrapper from '../Add/AddBookWrapper';
import { showConfirmationDialog } from 'src/utils/showConfirmationDialog';
import { showToast } from 'src/utils/showToaster';
import ATMMenu from 'src/components/UI/atoms/ATMMenu/ATMMenu';
import EditBookWrapper from '../Edit/EditBookWrapper';
import { useChangeStatusBookByIdMutation, useDeleteBookByIdMutation, useGetAllBookDataQuery } from 'src/services/BookService';
import { usePermission } from 'src/hooks/usePermission';

type Props = {};

const BooksListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const { items, totalItems, page, rowsPerPage, isOpenAddDialog, isOpenEditDialog, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.book);
  const [selectedBookId, setSelectedBookId] = useState<string>()
  const [deleteBook] = useDeleteBookByIdMutation()
  const [changeStatusBook] = useChangeStatusBookByIdMutation()
  const { data, isLoading, isFetching } = useGetAllBookDataQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: [
      "bookName",
    ],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  // Setting Module Data
  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setIsTableLoading(false));
      dispatch(setTotalItems(data?.totalItem || 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  const handleDeleteBook = (row: string) => {
    showConfirmationDialog({
      title: "Hands Up",
      text: "Are you sure want to delete this book ?",
      icon: "question",
      showCancelButton: true,
      next: (result) => {
        if (result?.isConfirmed) {
          deleteBook(row).then((res: any) => {
            if (res.error) {
              showToast("error", res?.error?.data?.message);
            } else {
              showToast("success", res?.data?.message);
            }
          });
        }
      },
    });
  };

  const handleChangeStatusBook = (row: any) => {
    const actionLabel = row?.isActive ? "deactive" : "active";
    showConfirmationDialog({
      title: "Hands Up",
      text: `Are you sure want to ${actionLabel} this book ?`,
      icon: "question",
      showCancelButton: true,
      next: (result) => {
        if (result?.isConfirmed) {
          changeStatusBook({ id: row?._id }).then((res: any) => {
            if (res.error) {
              showToast("error", res?.error?.data?.message);
            } else {
              showToast("success", res?.data?.message);
            }
          });
        }
      },
    });
  };

const moduleName = "BOOK";

const canEdit = usePermission(moduleName, "UPDATE");
const canDelete = usePermission(moduleName, "DELETE");
const canActive = usePermission(moduleName, "ACTIVE/DEACTIVE");

const columns: columnTypes[] = [
  { field: 'bookName', headerName: 'Book Name', flex: 'flex-[1_1_0%]' },
  {
    field: "action",
    headerName: "Actions",
    flex: "flex-[1_1_0%]",
    align:"center",
    extraClasses: "",
    renderCell: (row: any) => {
      const options = [];

      if (canEdit) {
        options.push({
          label: "Edit",
          onClick: () => {
            dispatch(setIsOpenEditDialog(true));
            setSelectedBookId(row?._id);
          },
        });
      }

      if (canActive) {
        options.push({
          label: row?.isActive ? "Deactive" : "Active",
          onClick: () => {
            handleChangeStatusBook(row);
          },
        });
      }

      if (canDelete) {
        options.push({
          label: "Delete",
          onClick: () => {
            handleDeleteBook(row?._id);
          },
        });
      }

      return <ATMMenu options={options} /> ;
    },
  },
];


  return (
    <>
      <div>
        <BookListing
          columns={columns}
          rows={items}
          paginationProps={{
            isTableLoading,
            totalItems,
            page,
            rowsPerPage,
            searchValue,
            setIsOpenAddDialog: (value) => dispatch(setIsOpenAddDialog(value)),
            setPage: (newPage) => dispatch(setPage(newPage)),
            setRowsPerPage: (newRowsPerPage) => dispatch(setRowsPerPage(newRowsPerPage)),
            setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
          }}
        />
      </div>
      {isOpenAddDialog ? (
        <AddBookWrapper
          onClose={() => dispatch(setIsOpenAddDialog(false))}
        />
      ) : null}
      {isOpenEditDialog ? (
        <EditBookWrapper
          onClose={() => dispatch(setIsOpenEditDialog(false))}
          selectedBookId={selectedBookId || ""}

        />
      ) : null}
    </>
  );
};

export default BooksListingWrapper;